<div
  #container
  class="roll-toast-message roll-shadow"
  [@messageState]="{
    value: 'visible',
    params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions }
  }"
  [ngClass]="{
    'roll-toast-message-info': message.severity === EMessageStatus.Information,
    'roll-toast-message-warn': message.severity === EMessageStatus.Warning,
    'roll-toast-message-error': message.severity === EMessageStatus.Error,
    'roll-toast-message-success': message.severity === EMessageStatus.Success,
    'roll-toast-message-alert': message.severity === EMessageStatus.Alert
  }"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="roll-toast-message-content">
    <mat-icon class="roll-toast-icon">
      {{ getIconName(message.severity) }}
    </mat-icon>
    <div class="roll-toast-message-text-content">
      <div class="roll-toast-summary" *ngIf="message.summary">{{ message.summary | translate }}</div>
      <div class="roll-toast-detail" *ngIf="message.detail" [innerHtml]="message.detail | translate"></div>
    </div>
    <button
      mat-icon-button
      tabindex="0"
      class="roll-toast-close-icon"
      id="roll-toast-close-icon"
      appSendAnalytics
      (click)="onCloseIconClick($event)"
      (keydown.enter)="onCloseIconClick($event)"
      attr.aria-label="{{ 'GENERIC.CLOSE' | translate }}"
      *ngIf="message.closable !== false">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
